/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { forkJoin } from 'rxjs';
import { tap } from 'rxjs/operators';
import { MyInjector } from '@src/app/app.module';
import { Field } from '@src/app/shared/field/Field';
import { SectionEditor } from '@src/app/shared/form/section-editor';
import { ServiceRequest } from '@src/app/model/serviceRequest';
import { RequestService } from '@src/app/modules/crm/request.service';
import { RequestCategory } from '@src/app/model/RequestCategory';
import { RequestCategoriesService } from '@src/app/modules/crm/request-categories.service';
import { SrTopic } from '@src/app/model/sr-topic';
import { SrClass } from '@src/app/model/sr-class';
import { SrTopicService } from '@src/app/modules/crm/sr-topic.service';
import { SrClassService } from '@src/app/modules/crm/sr-class.service';

export class RequestDetailsEditor extends SectionEditor<ServiceRequest> {
    protected svc = MyInjector.instance.get(RequestService);
    protected title = $localize`Request Details`;

    private cats: RequestCategory[] = [];
    private classes: SrClass[] = [];

    private catField = ServiceRequest.makeCategoryField();
    private topicClass = ServiceRequest.makeTopicAndClassFields(() => this.classes);

    protected loadRefData() {
        return forkJoin({
            cats: MyInjector.instance.get(RequestCategoriesService).get<RequestCategory>(false),
            topics: MyInjector.instance.get(SrTopicService).get<SrTopic>(false),
            classes: MyInjector.instance.get(SrClassService).get<SrClass>(false),
        }).pipe(tap(r => {
            this.cats = r.cats;
            this.classes = r.classes;
            this.topicClass.topicField.setPicklistItems(r.topics);
        }));
    }

    protected buildFields(): Field[] {
        return [
            ServiceRequest.getSourcePicklist(),
            ServiceRequest.getPriorityField(),
            this.catField,
            this.topicClass.topicField,
            this.topicClass.classField,
            ServiceRequest.getBillableField(),
            ServiceRequest.makeParentField(this.svc),
        ];
    }

    protected beforeEdit(sr: ServiceRequest): ServiceRequest {
        this.catField.setPicklistItems(this.cats.filter(c => c.teamId === sr.agentTeamId));
        this.topicClass.narrowClasses(sr.srTopic);
        return sr;
    }
}
